import { EChartsCoreOption } from 'echarts';
import {
  ChartDataResponseResult,
  ChartProps,
  DataRecordValue,
  QueryFormColumn,
  QueryFormData,
  QueryFormMetric,
  SetDataMaskHook,
} from '@superset-ui/core';
import {
  DEFAULT_LEGEND_FORM_DATA,
  EchartsLegendFormData,
} from '../../../types';

export type EchartsWaterfallFormData = QueryFormData &
  EchartsLegendFormData & {
    groupby: QueryFormData[];
    metric: QueryFormMetric;
    showLabels: boolean;
    // numberFormat: string;
    // emitFilter: boolean;
};

export interface EchartsWaterfallChartProps
  extends ChartProps<EchartsWaterfallFormData> {
  formData: EchartsWaterfallFormData;
  queriesData: ChartDataResponseResult[];
}

// @ts-ignore
export const DEFAULT_FORM_DATA: EchartsWaterfallFormData = {
  ...DEFAULT_LEGEND_FORM_DATA,
  groupby: [],
  showLabels: true,
//   numberFormat: 'SMART_NUMBER',
//   emitFilter: false,
};

export interface WaterfallChartTransformedProps {
  formData: EchartsWaterfallFormData;
  height: number;
  width: number;
  echartOptions: EChartsCoreOption;
  setDataMask: SetDataMaskHook;
  labelMap: Record<string, DataRecordValue[]>;
  groupby: QueryFormColumn[];
}